import { Component, input } from '@angular/core';
import { DownloadableFileCardComponent } from '@app/components/downloadable-file-card/downloadable-file-card.component';
import { FileInfo } from '@app/models/document.model';

@Component({
  selector: 'app-downloadable-file-list',
  standalone: true,
  imports: [DownloadableFileCardComponent],
  templateUrl: './downloadable-file-list.component.html',
  styleUrl: './downloadable-file-list.component.scss',
})
export class DownloadableFileListComponent {
  files = input.required<FileInfo[]>();
}
